module.exports = __webpack_public_path__ + "img/smiling-bg.73c04fef.png";